import { css } from 'styled-components';

export const termsCss = css`

body,
th,
td,
input,
select,
textarea,
div {
  font-size: 12px;
}

  table {
    width: 1024px;
    border: 1px solid #444444;
    border-collapse: collapse;
    margin: auto;
    text-align: center;
    margin-top: 100px;
  }
  
th,
td {
  border: 1px solid #444444;
}
`;
